import { environmentConfig } from "@src/appV2/environment";

interface GetCommentUrlParams {
  workplaceId: string;
  commentId: string;
}

export function getCommentUrl(params: GetCommentUrlParams): string {
  const { workplaceId, commentId } = params;
  return `${environmentConfig.REACT_APP_SHIFT_REVIEW_API_URL}/workplaces/${workplaceId}/comments/${commentId}`;
}
